import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

import {GridActionsService} from '../../data-grid/grid-actions.service';
import { PriceyardService } from "../../modules/priceyard/services/priceyard.service";
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { BuyBoxGraphDetailsComponent } from '../buy-box-graph-details/buy-box-graph-details.component';

@Component({
  selector: "app-buy-box-cell-renderer",
  templateUrl: "./buy-box-cell-renderer.component.html",
  styleUrls: ["./buy-box-cell-renderer.component.scss"],
})
export class BuyBoxCellRendererComponent implements OnDestroy {
  params: any;
  edit = false;
  private destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  startEditing(e, params) {
    e.stopPropagation();
    this.params.api.startEditingCell({
      rowIndex: params.rowIndex,
      colKey: params.column.colId,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  buyBoxDetail(event: MouseEvent){
    event.stopPropagation();
    const dialog = this.dialog.open(BuyBoxGraphDetailsComponent, {
      width: "500px",
      position: this.getDialogRightPosition(event),
      data:{
        accountSkuId: this.params.data.AccountSkuId
      }
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe(); 
  }

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      bottom: targetPosision.bottom < 612 ? targetPosision.bottom + "px" : "612px",
      left: targetPosision.left + "px",
      right: targetPosision.right + "px",
      top: targetPosision.top > 500 ? "500px" : targetPosision.top + "px",
    };  
 }
}